/**
 * Single source of truth for tag -> URL slug conversion.
 * Must stay in sync with public/generate-sitemap.js and scripts/prerender.js,
 * which use the same rule: lowercase, spaces -> hyphens.
 *
 * Note: tags that already contain hyphens (e.g. "Real-time", "Blue-Green")
 * keep them, so matching must compare slug-to-slug, never de-slugify.
 */
export const slugifyTag = (tag) => tag.toLowerCase().replace(/\s+/g, '-');
